// extracted by mini-css-extract-plugin
module.exports = {"parent":"Loading_parent__2NK8O","loader":"Loading_loader__2CqNh"};